module.exports = __webpack_public_path__ + "static/media/LTO_Promo_Image@3x.6407e4a6.png";